import { render } from "./GetExtensionButton.vue?vue&type=template&id=2933b679&scoped=true"
import script from "./GetExtensionButton.vue?vue&type=script&lang=js"
export * from "./GetExtensionButton.vue?vue&type=script&lang=js"

import "./GetExtensionButton.vue?vue&type=style&index=0&id=2933b679&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2933b679"]])

export default __exports__